// Content for the Permis ATNA « La solution » section. Interface values are illustrative.
export type Bi = { fr: string; en: string }

export const solutionCopy = {
  eyebrow: { fr: 'La solution', en: 'The solution' },
  line1: { fr: 'Du projet à une demande', en: 'From project to a' },
  line2: { fr: 'prête à traiter.', en: 'ready-to-process application.' },
  line3: { fr: 'ATNA comprend,', en: 'ATNA understands,' },
  line4: { fr: 'vérifie et orchestre.', en: 'verifies and orchestrates.' },
  bodyLead: { fr: 'Permis ATNA', en: 'ATNA Permits' },
  bodyRest: {
    fr: ' relie l’identité, la propriété, les règles, les documents et le processus municipal pour guider le citoyen et remettre à vos équipes une demande mieux préparée, vérifiée et traçable.',
    en: ' connects identity, property, rules, documents and the municipal process to guide residents and give your teams a better-prepared, verified and traceable application.',
  },
  final1: { fr: 'Pas simplement un permis en ligne.', en: 'Not just an online permit.' },
  final2: { fr: 'Un processus intelligent de bout en bout.', en: 'An intelligent end-to-end process.' },
}

export const propertyContext = {
  title: { fr: 'Propriété identifiée', en: 'Property identified' },
  items: [
    { key: 'id', label: { fr: 'Identité du citoyen', en: 'Resident identity' } },
    { key: 'address', label: { fr: 'Adresse et propriété', en: 'Address and property' } },
    { key: 'zoning', label: { fr: 'Zonage applicable', en: 'Applicable zoning' } },
    { key: 'history', label: { fr: 'Historique des permis', en: 'Permit history' } },
  ] as { key: 'id' | 'address' | 'zoning' | 'history'; label: Bi }[],
}

export const verifiedAnswer = {
  title: { fr: 'Réponse vérifiée par ATNA', en: 'Answer verified by ATNA' },
  items: [
    { key: 'city', label: { fr: 'Ville : Clarence-Rockland', en: 'City: Clarence-Rockland' } },
    { key: 'property', label: { fr: 'Propriété : 123, rue Exemple', en: 'Property: 123 Example St.' } },
    { key: 'rule', label: { fr: 'Règlement applicable', en: 'Applicable by-law' } },
    { key: 'version', label: { fr: 'Version en vigueur', en: 'Current version' } },
    { key: 'date', label: { fr: 'Vérifié aujourd’hui', en: 'Verified today' } },
  ] as { key: 'city' | 'property' | 'rule' | 'version' | 'date'; label: Bi }[],
  scoreLabel: { fr: 'Indice de confiance', en: 'Confidence score' } as Bi,
  score: 4,
  confidence: { fr: 'Confiance élevée', en: 'High confidence' },
  note: { fr: 'Sources officielles vérifiées avant la réponse.', en: 'Official sources verified before answering.' },
}

export const readyPhone = {
  title: { fr: 'Votre demande est presque prête', en: 'Your application is almost ready' },
  progress: 80,
  items: [
    { name: { fr: 'Formulaire prérempli', en: 'Pre-filled form' }, meta: null, kind: 'form' },
    { name: { fr: 'Plan d’implantation', en: 'Site plan' }, meta: { fr: 'PDF · 1,2 Mo', en: 'PDF · 1.2 MB' }, kind: 'file' },
    { name: { fr: 'Plans de construction', en: 'Construction plans' }, meta: { fr: 'PDF · 2,1 Mo', en: 'PDF · 2.1 MB' }, kind: 'file' },
    { name: { fr: 'Photos du site', en: 'Site photos' }, meta: { fr: '3 photos', en: '3 photos' }, kind: 'photo' },
    { name: { fr: 'Paiement', en: 'Payment' }, meta: { fr: 'Carte de crédit', en: 'Credit card' }, kind: 'pay' },
  ] as { name: Bi; meta: Bi | null; kind: 'form' | 'file' | 'photo' | 'pay' }[],
  warnTitle: { fr: 'Une information à compléter', en: 'One detail to complete' },
  warnBody: { fr: 'Distance entre la terrasse et la limite latérale.', en: 'Distance between the deck and the side property line.' },
  cta: { fr: 'Compléter ma demande', en: 'Complete my application' },
}

export const caseDashboard = {
  city: 'Clarence-Rockland',
  title: { fr: 'Demande nº P-2026-1247',en: 'Application #P-2026-1247' },
  status: { fr: 'Prête à traiter', en: 'Ready to process' },
  checks: [
    { label: { fr: 'Prévalidation ATNA', en: 'ATNA pre-validation' }, sub: { fr: 'Complète', en: 'Complete' } },
    { label: { fr: 'Documents complets', en: 'Documents complete' }, sub: null },
    { label: { fr: 'Paiement reçu', en: 'Payment received' }, sub: null },
    { label: { fr: 'Règles vérifiées', en: 'Rules verified' }, sub: null },
  ] as { label: Bi; sub: Bi | null }[],
  tabs: [
    { fr: 'Suivi du dossier', en: 'Case tracking' },
    { fr: 'Documents', en: 'Documents' },
    { fr: 'Communications', en: 'Communications' },
    { fr: 'Historique', en: 'History' },
  ] as Bi[],
  workflow: [
    { label: { fr: 'Réception', en: 'Intake' }, status: { fr: 'Terminé', en: 'Completed' }, state: 'done' },
    { label: { fr: 'Urbanisme', en: 'Planning' }, status: { fr: 'En cours', en: 'In progress' }, state: 'current' },
    { label: { fr: 'Inspection', en: 'Inspection' }, status: { fr: 'À venir', en: 'Upcoming' }, state: 'next' },
    { label: { fr: 'Décision', en: 'Decision' }, status: { fr: 'À venir', en: 'Upcoming' }, state: 'next' },
    { label: { fr: 'Permis', en: 'Permit' }, status: { fr: 'À venir', en: 'Upcoming' }, state: 'next' },
  ] as { label: Bi; status: Bi; state: 'done' | 'current' | 'next' }[],
  sla: { label: { fr: 'Délai cible', en: 'Target SLA' }, value: { fr: '10 jours', en: '10 days' }, sub: { fr: 'Délai selon le type de permis', en: 'Timeline by permit type' } },
  owner: { label: { fr: 'Responsable', en: 'Owner' }, value: { fr: 'Urbanisme', en: 'Planning' }, nextLabel: { fr: 'Prochaine action', en: 'Next action' }, next: { fr: 'Analyse du dossier', en: 'Case review' } },
  reco: {
    title: { fr: 'ATNA recommande', en: 'ATNA recommends' },
    body: { fr: 'Dossier complet. Aucun document supplémentaire requis avant l’analyse d’urbanisme.', en: 'File complete. No additional documents required before the planning review.' },
  },
}

export const operatingSteps: { key: 'chat' | 'pin' | 'shield' | 'doc' | 'gear'; verb: Bi; body: Bi }[] = [
  { key: 'chat', verb: { fr: 'Comprend', en: 'Understands' }, body: { fr: 'Le projet et l’intention du citoyen.', en: 'The resident’s project and intent.' } },
  { key: 'pin', verb: { fr: 'Contextualise', en: 'Contextualizes' }, body: { fr: 'Identité, propriété, SIG et historique.', en: 'Identity, property, GIS and history.' } },
  { key: 'shield', verb: { fr: 'Vérifie', en: 'Verifies' }, body: { fr: 'Ville, règles, version, date et sources officielles.', en: 'City, rules, version, date and official sources.' } },
  { key: 'doc', verb: { fr: 'Prépare', en: 'Prepares' }, body: { fr: 'Formulaire, documents et paiement.', en: 'Form, documents and payment.' } },
  { key: 'gear', verb: { fr: 'Orchestre', en: 'Orchestrates' }, body: { fr: 'Flux de travail, inspections, communications et suivi.', en: 'Workflow, inspections, communications and follow-up.' } },
]
